import { Box } from '@mui/material';
import { Suspense, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import { RouteBarSignal } from './RouteBar';
import { PageEnter } from './PageEnter';
import { AppErrorBoundary } from '@/components/common/AppErrorBoundary';
import { PageLoader } from '@/components/common/Loaders';
import { layout } from '@/theme/tokens';

/**
 * The console shell: the top bar across the whole width — the brand, the
 * module switcher and the person's own chrome — and under it the active
 * module's rail beside the page. A page that belongs to no module has no rail
 * and runs full width (the apps grid, the dashboard, profile, settings).
 */
export function DashboardLayout() {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100dvh', bgcolor: 'background.default' }}>
      <Topbar onMenuClick={() => setMobileOpen(true)} />
      <Box sx={{ flex: 1, display: 'flex', minWidth: 0 }}>
        <Sidebar mobileOpen={mobileOpen} onMobileClose={() => setMobileOpen(false)} />
        <Box
          component="main"
          sx={{
            flex: 1,
            minWidth: 0,
            px: { xs: 2, md: 4 },
            pt: { xs: 2.5, md: 3.5 },
            pb: 6,
          }}
        >
          <Box sx={{ width: '100%', maxWidth: layout.contentMaxWidth, mx: 'auto' }}>
            <AppErrorBoundary>
              <Suspense
                fallback={
                  <>
                    <RouteBarSignal />
                    <PageLoader />
                  </>
                }
              >
                {/* Keyed on the path inside `PageEnter`: a new page mounts fresh and
                    enters; a tab or a filter in the query string does not. */}
                <PageEnter>
                  <Outlet />
                </PageEnter>
              </Suspense>
            </AppErrorBoundary>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
